import React from 'react';

const ExpertiseCard = ({ item }) => {
  return (
    <div className="expertise-card">
      <span className="expertise-icon">{item.icon}</span>
      <h3>{item.title}</h3>
      <ul>
        {item.skills.map((skill, i) => (
          <li key={i}>{skill}</li>
        ))}
      </ul>
    </div>
  );
};

export default ExpertiseCard;
